//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum FeeTermType {

  /**
   * One-time fee charged per reservation
   */
  Single = 1,

  /**
   * Fee charged per day
   */
  Daily = 2,

}

export default FeeTermType;